import { NeighbouringRightsAssignment } from '../../../model/product/countries-shops';
import { WizardFeatureState } from '../../../model/product/wizard';
import { getCountries } from './state.helper';

export function countriesToggled(state: WizardFeatureState, toggleList: string[]) {
  const countries = getCountries(state.value.countrySelection.countries, toggleList);
  const neighbouring = state.value.neighbouringRightsSelection;
  const neighbouringCountries = neighbouring.countries.filter((c) => countries.includes(c));
  const newNeighbouringAssignments = countries
    .filter((c) => neighbouring.assignments.every((a) => a.id !== c))
    .map(
      (c): NeighbouringRightsAssignment => ({
        id: c,
        endDate: undefined,
        startDate: undefined,
        percentage: '',
      }),
    );

  return {
    ...state,
    value: {
      ...state.value,
      countrySelection: {
        ...state.value.countrySelection,
        countries,
      },
      neighbouringRightsSelection: {
        ...neighbouring,
        countries: neighbouringCountries,
        assignments:
          newNeighbouringAssignments.length === 0
            ? neighbouring.assignments
            : neighbouring.assignments.concat(newNeighbouringAssignments),
      },
    },
  };
}
